module.exports = __webpack_public_path__ + "static/media/gicon-3.f6329e26.png";